module.exports = __webpack_public_path__ + "static/media/nutrition-2.7ed60194.png";